import { usersApi } from 'entities/users';

type UploadFileResponseDataType = {
  file_path: null | string;
};

const uploadFileApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation<UploadFileResponseDataType, any>({
      query: (form: any) => ({
        url: '/news-pages/admin/upload-file/',
        method: 'POST',
        body: form,
      }),
    }),
  }),
});

export const { useUploadFileMutation } = uploadFileApi;
